import {
    Business_path_percentage,
    General_path_percentage,
    Study_path_percentage,
    Travel_path_percentage,
    VisaPurposes,
    Work_path_percentage,
} from 'data/constants/constants';

export const getFormPath_perc = (purpose: string, hasSpouse?: string, hasFamily?: string) => {
    switch (purpose) {
        case VisaPurposes.TRAVEL:
            return Travel_path_percentage(hasSpouse, hasFamily);
        case VisaPurposes.WORK:
            return Work_path_percentage(hasSpouse, hasFamily);
        case VisaPurposes.BUSINESS:
            return Business_path_percentage(hasSpouse, hasFamily);
        case VisaPurposes.STUDY:
            return Study_path_percentage(hasSpouse, hasFamily);
        case VisaPurposes.GENERAL:
            return General_path_percentage(hasSpouse, hasFamily);
        case VisaPurposes.NOPREFERENCE:
            return General_path_percentage(hasSpouse, hasFamily);
        default:
            return Travel_path_percentage(hasSpouse, hasFamily);
    }
};
